module.exports = __webpack_public_path__ + "static/media/fa-solid-900.46e7cec6.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.eot
// module id = 529
// module chunks = 0